export default "__VITE_ASSET__BCN7EWvT__"